import { usePlatform } from "@platform/PlatformContext";
import { DashboardHeader } from "./DashboardHeader";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";

type Props = {
  // Pass navigation component as children
  children: React.ReactNode;
};

export function DashboardHeaderContainer({ children }: Props) {
  const { isMobileMenuOpen, openMobileMenu, closeMobileMenu } = useMobileMenu();

  const { isChatDisabled } = usePlatform();

  return (
    <DashboardHeader
      isMobileMenuOpen={isMobileMenuOpen ?? false}
      openMobileMenu={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
      isChatDisabled={isChatDisabled}
    >
      {children}
    </DashboardHeader>
  );
}

export default DashboardHeaderContainer;
